import React, { useEffect, useState, useRef } from "react";
import { bm_date, drawPrice } from "../utils/Utils";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";


export default function OrderTitleSelector(props) {

    const { callback = () => {}, route = "", controller = "", signal = {}, initialData = [], value = "" } = props;
    
    const [ data, setData ] = useState(initialData.rows || []);
    const [ selected, setSelected ] = useState((initialData.rows || [])[0] || {});
    const [ loading, setLoading ] = useState(false);
    const offsetRef = useRef(100);

    const generateKey = () => {
        return `${Math.random().toString(36).substr(2, 9)}`;
    };

    const loadMore = () => {
        if (offsetRef.current >= initialData.total) return;
        if (loading) return;
        setLoading(true);
        pubCall("order.getInvoiceTitleOptions", { supplier: value, limit: 100, offset: offsetRef.current }, (_s, _r) => {
            if (_s) {
                const rowsWithKeys = _r.rows?.map(row => ({ ...row, key: generateKey() })) || [];
                setData(prev => [...prev, ...rowsWithKeys]);
                offsetRef.current += 100;
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const columns = [
        { key: "status", align: "left", title: <>Stat</>, width: 100 },
        { key: "order_number", align: "left", title: <>Order</>, width: 120 },
        { key: "quantity", align: "left", title: <>Qty</>, width: 100 },
        { key: "primary_code", align: "left", title: <>ISBN</>, width: 200 },
        { key: "title", align: "left", title: <>Title</>, width: 150 },
        { key: "invoice_price", align: "left", title: <>InvPrice</>, width: 100, render: (e) => {
            return drawPrice(e, true);
        }},
        { key: "supplier_discount", align: "left", title: <>&&</>, width: 100 },
    ]


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.key === selected?.key);
        const nextIndex = currentIndex + _rows;
        
        if (nextIndex >= data.length - 5 && !loading) {
            loadMore();
        }
        
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.key === selected?.key) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}    
    };

    const nav = [
        { key: KBD.ESCAPE, action: () => callback() },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.ENTER, text: "Enter",action: () => callback(value) },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [KBD.ESCAPE, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [selected, data])

    return (
        <VirtualTable
            columns={columns}
            row_key={"key"}
            data={data}
            loading={loading}
            current={selected}
            width={600}
            onSelect={(row) => setSelected(row)}
            onDoubleClick={() => callback(selected)}
        />
    )
}